import { marked } from "marked";
import React, { memo, useMemo } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import styles from "./MemoizedMarkdown.scss";

const parseMarkdownIntoBlocks = (markdown) => {
    const tokens = marked.lexer(markdown || "");
    return tokens.map((token) => token.raw);
};

const MemoizedMarkdownBlock = memo(
    function MemoizedMarkdownBlock({ content }) {
        return <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>;
    },
    (prevProps, nextProps) => prevProps.content === nextProps.content
);

export const MemoizedMarkdown = memo(function MemoizedMarkdown({ id, content }) {
    const blocks = useMemo(() => parseMarkdownIntoBlocks(content), [content]);

    return (
        <div className={styles.base}>
            {blocks.map((block, index) => (
                <MemoizedMarkdownBlock content={block} key={`${id}-block_${index}`} />
            ))}
        </div>
    );
});
